import Vue from "vue";

Vue.component("annexes-multiselect", {
    props: [
        "value",
        "dynamicValue",
        "language",
        "disabled",
        "partyId",
        "showDocuments"
    ],
    data() {
        return {
            loading: false,
            myValue: [],
            filteredAnnexes: [],
            annexes: [],
            initializing: false,
            loadingText: window.labels.loading,
            isDisabled: this.disabled,
            isDocumentsShown: false,
            documentList: []
        }
    },
    methods: {
        getFilteredMembers(name) {
            this.filteredAnnexes = this.annexes.filter((member) => {
                return member.name
                    .toString()
                    .toLowerCase()
                    .indexOf(name.toLowerCase()) >= 0
            })
        },
        removeTag(val) {
        },
        getAnnexUrl: function (id, number) {
            return `${eval("window.urls.annex" + number)}/${id}`;
        },
    },
    watch: {
        myValue: function (value) {
            let tempValue = [];
            let tempDocuments = [];

            value.forEach(member => {
                tempValue.push(member.id);
                
            });

            this.$emit("update:value", tempValue);
        },
        dynamicValue: function (value) {
            if (value.length > 0) {
                this.myValue = [];
                value.forEach(memberId => {
                    var items = this.annexes.filter(member => member.id == memberId);
                    if (items.length > 0) {
                        this.myValue.push(items[0]);
                    }
                });
            }
            else {
                this.myValue = [];
            }

        },
        partyId: function (val) {
            if (val) {
                this.loading = true;
                this.$services.annexes.getByPartyId({
                    language: this.language,
                    partyId: val
                })
                    .then((data) => {
                        console.log(data);
                        this.annexes = data;
                        this.filteredAnnexes = data;
                        this.loading = false;
                        if (this.value && this.value.length > 0) {
                            this.value.forEach(memberId => {
                                var items = this.annexes.filter(member => member.id == memberId);
                                if (items.length > 0) {
                                    this.myValue.push(items[0]);
                                }
                            });
                        }
                    });
            }
        },
       
    },
    mounted() {

        //var annexes = window.enums.annexes.map((x) => { return { id: x.id, displayName: x.name }; })
        //this.annexes = annexes;
        //this.filteredAnnexes = annexes;
        this.loading = true;
        if (this.partyId) {
            this.$services.annexes.getByPartyId({
                language: this.language,
                partyId: this.partyId
            })
                .then((data) => {

                    this.annexes = data;
                    this.filteredAnnexes = data;
                    console.log(data)
                    this.loading = false;
                    if (this.value && this.value.length > 0) {
                        console.log(this.value)
                        this.value.forEach(memberId => {
                            var items = this.annexes.filter(member => member.id == memberId);
                            if (items.length > 0) {
                                this.myValue.push(items[0]);
                            }
                        });
                    }
                });
        } else {
            //if (this.value && this.value.length > 0) {
            //    this.value.forEach(memberId => {
            //        var items = this.annexes.filter(member => member.id == memberId);
            //        if (items.length > 0) {
            //            this.myValue.push(items[0]);
            //        }
            //    });

            //}
        }
        this.loading = false;


    },
    template: `
	<div style="width:100%">
		<div v-if="loading">
			<loading :loading-text="loadingText"></loading>
		</div>
		<div v-else>
		    <b-field expanded>
			
			    <b-taginput
                    expanded
				    autocomplete
				    v-model="myValue"
				    :data="filteredAnnexes"
				    @typing="getFilteredMembers"
				    field="displayName"
				    :disabled="isDisabled"
				    :loading="loading"
				    :open-on-focus="true"
				    ref="annextaginput"
			    >
                 <template slot-scope="props">
                    <div class="media">
    
                        <div class="media-content" v-html="props.option.displayName">
                           
                       
                        </div>
                    </div>
                </template>
			        <template #selected="props">
				        <b-tag						
                                v-for="(tag, index) in props.tags"
                                :key="index"
                                rounded
                                :tabstop="false"
                                closable
                                @close="$refs.annextaginput.removeTag(index, $event)">
						          <a class="button is-white is-small " :href="tag.document" target="_blank">
                                    <span class="icon has-text-info">
                                      <i class="fas fa-file-word is-info"></i>
                                    </span>
                                    <span v-html="tag.displayName"></span>
                                  </a>
                            </b-tag>
			        </template>
			    </b-taginput>
                 <p class="control">
                <b-button type="is-primary" icon-right="list" @click="isDocumentsShown = !isDocumentsShown" />
            </p>
			</b-field>
            <div class="box" v-if="isDocumentsShown">
                <b-table :data="myValue" detail-key="id">
                   <b-table-column width="100%">
						<template v-slot="props">
							<a :href="getAnnexUrl(props.row.id, props.row.number)">
								<span v-html="props.row.displayName"></span>
							</a>
							<template v-if="props.row.documents != null && props.row.documents.length > 0">
								<a class="browse-annex-lls-link pr-2" v-for="document in props.row.documents" :href="document" target="_blank">
									<img src="/images/doc.png" />
								</a>
							</template>
							<template v-if="props.row.rank">
								<b-tooltip :label="rankTooltip" multilined class="annex-rank-icon mr-2">
									<i data-toggle="tooltip" title="" :class="'fa fa-flag ' + props.row.rankClass"></i>
								</b-tooltip>
							</template>
						</template>
					</b-table-column>
                </b-table>
            </div>
		</div>
	</div>
	`
});